import { useCallback, useState } from 'react';
import { retrieveWhitelistedUsers } from 'src/pages/admin/services/whitelistService';

export interface WhitelistedUser {
  userId: string;
  walletAddress: string;
  proxyWalletAddress: string;
  email: string;
  unlockSource: string;
  redemptionCode: string | null;
  registeredAt: string | number;
  addedBy: string | null;
  status: string;
}

const useWhitelistedUsers = () => {
  const [records, setRecords] = useState<WhitelistedUser[]>([]);
  const [total, setTotal] = useState<number>(0);

  const retrieve = useCallback(
    async (page: number, pageSize: number, search?: string, unlockSource?: string, redemptionCode?: string) => {
      try {
        const response = await retrieveWhitelistedUsers(page, pageSize, search, unlockSource, redemptionCode);
        setRecords(response.data.items ?? response.data.data ?? []);
        setTotal(response.data.total ?? 0);
      } catch (error) {
        console.log('error: ', error);
      }
    },
    []
  );

  return { retrieve, records, total };
};

export default useWhitelistedUsers;
